import { ActionButton } from '../action-button';
import { Modal } from '../modal';
import { ButtonsRow, Content } from './style';

type AlertModalProps = {
  title?: string;
  isVisible: boolean;
  onConfirm: () => void;
  children: string | React.ReactNode;
};

export const AlertModal = ({
  title = 'שגיאה',
  children,
  isVisible,
  onConfirm,
}: AlertModalProps) => {
  return (
    <Modal title={title} isVisible={isVisible}>
      <Content>{children}</Content>

      <ButtonsRow>
        <ActionButton title="אישור" onClick={onConfirm} type="submit" />
      </ButtonsRow>
    </Modal>
  );
};
